import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Button, Divider, Upload, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const FormMainSliderAdmin = ({ onSubmit, isSaving, beforeUpload, handleCancelImageSlider, handlePreviewImageSlider, handleChangeImageSlider, fileListSlider, previewImageSlider, previewVisibleImageSlider }) => {
    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
          onSuccess("ok");
        }, 0);
    };

    /*const normFile = e => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
    };*/

    const uploadButton = () => (
        <div>
          <PlusOutlined />
          <div className="ant-upload-text">Agregar</div>
        </div>
    );
    
    return (
        <Grid styles={{ width: "100%" }}>
            <Form onFinish={onSubmit}>
                <Divider>Fotos slider principal</Divider>
                <Row>
                    <Col xs={12} sm={12}>
                        <Form.Item name="upload" valuePropName="imagesSlider">
                            <Upload
                            name="slider"
                            fileList={fileListSlider}
                            accept="image/*"
                            multiple={true}
                            listType="picture-card"
                            customRequest={dummyRequest}
                            beforeUpload={beforeUpload}
                            onPreview={handlePreviewImageSlider}
                            onChange={handleChangeImageSlider}
                            >
                                {fileListSlider.length >= 10 ? null : uploadButton()}
                            </Upload>
                            <Modal visible={previewVisibleImageSlider} footer={null} onCancel={handleCancelImageSlider}>
                                <img alt="images" style={{ width: '100%' }} src={previewImageSlider} />
                            </Modal>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        <Form.Item>
                            {
                                isSaving ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Guardando
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit">
                                        Guardar
                                    </Button>
                            }
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
    );
};

FormMainSliderAdmin.propTypes = {
};

export default FormMainSliderAdmin;